import React, { useState } from 'react'
import InfoModal from './InfoModal'
import arrow from "../images/arrow.png"
function Simplified_div({headingNo,heading,showButton,children,caseStudy}) {
    const [isModalVisible, setIsModalVisible] = useState(false)
    
      const showModal = () => {
        setIsModalVisible(true)
      }
    
      const handleOk = () => {
        setIsModalVisible(false)
      }
    
      const handleCancel = () => {
        setIsModalVisible(false)
      }
      const solutionsData= [
        {
          peragraph: 'Define Requirements',
          list: [
            'Clearly outline your business objectives and identify the specific challenges or needs that the software solution should address.',
            'List down the essential features and functionalities required.'
          ]
        },
        {
          peragraph: 'Demo and Evaluation',
          list: [
            "Schedule product demonstrations. ",
            "Evaluate the software's usability, features, and performance. ",
            "Engage key stakeholders in the evaluation process."
          ]
        },
        {
          peragraph: 'Scalability and Integration',
          list: [
            "Identify the potential integrations required by the customer.",
            "Plan the implementation of identified integrations."
          ]
        },
        {
          peragraph: 'UAT & User Feedback',
          list: [
            "UAT period allows customer to assess the system performance and suitability for the specific business needs.",
            "Customer’s insights can provide valuable perspectives on usability, functionality mismatch."
          ]
        },
        {
          peragraph: 'User Training',
          list: [
            " User training is a critical component of successfully implementing the software solution.",
            "Proper training ensures that users can effectively and efficiently utilize the software, maximizing its benefits."
          ]
        },
        {
          peragraph: 'Post-Implementation Support',
          list: [
            "Provide ongoing support for users.",
            "Address any post-implementation issues.",
            "Evaluate and implement system enhancements based on feedback.",
          ]
        }
      ]
  return (
    <>
    {heading?<div className="simplified_div_data">
        {headingNo&&<h2 className="simplified_heading_No">{headingNo}</h2>}
        <div className="simplified_card_content">
          <h6 className="simplified_div_heading">
              <strong>{heading}</strong>
          </h6>
          <ul className="simplified_div_list_div">
              {children}
          </ul>
          {showButton&&<button className="simplified_div_button" onClick={showModal}>
              Let"s Discuss
              <img src={arrow} width="20px" style={{ marginLeft: "4px" }} alt="Discuss arrow" className="button_img"/>
          </button>}
        </div>
    </div>:
    solutionsData.map((data,index)=><div key={index} className="simplified_div_data">
        {!caseStudy&&<h2 className="simplified_heading_No">0{index+1}</h2>}
        <h6 className="simplified_div_heading">
            <strong>{data.peragraph}</strong>
        </h6>
        <ul className="simplified_div_list_div">
            {data.list.map(list=><li>{list}</li>)}
        </ul>
        {index==0&&<button className="simplified_div_button" onClick={showModal}>
            Let’s Discuss
            <img src={arrow} width="20px" style={{ marginLeft: "4px" }} alt="Discuss arrow"/>
        </button>}
    </div>)}
    <InfoModal
    companyIsEnabled
    url="http://185.213.27.237:8066/Email/ContactUs"
    isModalVisible={isModalVisible}
    handleOk={handleOk}
    handleCancel={handleCancel}
    />
    </>
  )
}

export default Simplified_div